import React from 'react';
import { LocationSelectByAppIdContextProvider } from 'components/pepper-pay/LocationSelectByAppIdContext';
import { BlockListView } from 'components/pepper-pay/block-list';

export const BlockList: React.FC = () => (
    <LocationSelectByAppIdContextProvider>
        <BlockListView />
    </LocationSelectByAppIdContextProvider>
);
